/* src/app/modules/shared/components/documents/my-documents/my-documents.component.scss */
.document-list {
  margin: 10px;
}
.document-upload {
  margin: 10px;
}
.pdf_table {
  margin: 10px;
  margin-right: 20px;
}
.pdf_table table {
  width: 100%;
}
/*# sourceMappingURL=my-documents.component.css.map */
